import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button, FormText } from "reactstrap";
import Select from 'react-select';

export const FormProcessCreate = (props) => {
    const {
        catwsprocess, datadeterminations, validaciones,
        method, handleInputChange, handleSearchWSS, loading,
        toggle, modal, modalTitle, saveCreate, saveUpdate, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        handleUpdateValues, handleSelectValues, formValues,methodAction,handleSelectValuesNew,button,
        id_exam,idwsconfig, order_element, name,comment_dilutions_colonies,is_lm, is_ec
    } = props;

    const {
        name_ws_valid,
        id_type_sample_valid,
        list_determinations_valid

    } = validaciones
console.log(name,"name");
    return (
        <Form className='' role="form" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>NOMBRE DEL PROCESO <span className='f-16' style={{ color: "#0079C7" }}>*</span>:</Label>
                            <Input
                                className='form-control form-control-sm input-air-primary'
                                type='text'
                                name="name"
                                value={formValues.name}
                                onChange={handleInputChange}
                                autoComplete="off"
                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>

                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>COMENTARIO COLONIAS/DILUSIONES:</Label>
                            <Input
                                className='form-control form-control-sm input-air-primary'
                                type='text'
                                name="comment_dilutions_colonies"
                                value={formValues.comment_dilutions_colonies}
                                onChange={handleInputChange}
                                autoComplete="off"
                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>NÚMERO DE TUBOS COLONIAS/DILUSIONES:</Label>
                            <Input
                                className='form-control form-control-sm input-air-primary'
                                type='number'
                                name="tubes"
                                value={formValues.tubes}
                                onChange={handleInputChange}
                                autoComplete="off"
                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col sm="12">
                        <Label className='col-form-label'>EXAMEN:</Label>
                        <FormGroup>
                            <select
                                className="form-control form-control-sm input-air-primary"
                                name="id_exam"
                                value={formValues.id_exam}
                                onChange={handleInputChange}
                            >
                                <option value={0}>Selecciona una opción</option>
                                {
                                    datadeterminations.map(element => (
                                        <option key={element.value} value={element.value}>
                                            {element.label}
                                        </option>
                                    ))
                                }
                            </select>
                            
                            <FormFeedback>Selecciones mínimo una determinación</FormFeedback>
                        </FormGroup>

                    </Col>

                    <Col md="12">
                        <FormGroup className="d-flex align-items-center">
                            <Label className="switch mb-0">
                                <Input
                                    type="checkbox"
                                    name="is_lm"
                                    onChange={(e) =>
                                        handleInputChange({
                                            target: {
                                                name: 'is_lm',
                                                value: e.target.checked,
                                            },
                                        })
                                    }
                                    checked={formValues.is_lm}
                                />
                                <span className="slider round"></span>
                            </Label>
                            <div className="ms-2">
                                ¿UTILIZA LOTES DE MEDIOS?
                                <span className='f-16' style={{ color: "#0079C7" }}>*</span>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup className="d-flex align-items-center">
                            <Label className="switch mb-0">
                                <Input
                                    type="checkbox"
                                    name="is_ec"
                                    onChange={(e) =>
                                        handleInputChange({
                                            target: {
                                                name: 'is_ec',
                                                value: e.target.checked,
                                            },
                                        })
                                    }
                                    checked={formValues.is_ec}


                                />
                                <span className="slider round"></span>
                            </Label>
                            <div className="ms-2">
                                ¿UTILIZA EQUIPOS Y CONSUMIBLES?
                                <span className='f-16' style={{ color: "#0079C7" }}>*</span>
                            </div>
                        </FormGroup>
                    </Col>



                </Row>
            </ModalBody>
            <ModalFooter>
                <Button outline color="primary" type="submit" size='sm' className={loading ? "disabled progress-bar-animated progresss-bar-striped" : ""}>
                {button}
                </Button>
                <Button size="sm" outline color='danger' type='button'>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}